import dumbData from './dumb.json';
import axios from 'axios';
import BaseHttp from '../../../plugins/baseHttp';
import { saveAs, } from 'file-saver';
import stateAndCities from './estados-cidades.json';

const get = () => {
  return new Promise((resolve,) => {
    setTimeout(() => {
      resolve(dumbData,);
    }, 10,);
  },);
};

const getStates = () => {
  const states = stateAndCities.estados.map((state,) => {
    return {
      sigla: state.sigla,
      nome: state.nome,
    };
  },);

  return Promise.resolve(states,);
};

const getCities = (uf,) => {
  const state = stateAndCities.estados.find((state,) => state.sigla == uf,);

  return Promise.resolve(state.cidades,);
};

const getFilePolicy = ({ filename, contentType, },) => {
  return BaseHttp.get(
    `/public/s3/getFilePolicy?filename=${filename}&contentType=${contentType}`,
  );
};

const downloadFile = (params,) => {
  let xhr = new XMLHttpRequest();

  xhr.open(
    'GET',
    BaseHttp.getAPIURL() +
      `/public/s3/downloadFile?region=${params.region}&key=${params.key}&bucket=${
        params.bucket
      }`,
  );

  xhr.responseType = 'blob';

  xhr.setRequestHeader(
    'Authorization',
    BaseHttp.requestLib.defaults.headers.common.Authorization,
  );

  xhr.onload = function () {
    saveAs(xhr.response, params.name,);
  };

  xhr.onerror = function () {
    console.error('could not download file',);
  };

  xhr.send();
};

const uploadPublicImage = (formData,) => {
  return BaseHttp.post('/images', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  },);
};

const updatePublicImage = (formData,) => {
  return BaseHttp.put('/images', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  },);
};

const uploadFileWithPolicy = async (endpoint, fileData, policy,) => {
  // (Way 2) https://stackoverflow.com/questions/16968945/convert-base64-png-data-to-javascript-file-objects/38936042#38936042
  const urltoFile = (url, filename, mimeType,) => {
    mimeType = mimeType || (url.match(/^data:([^;]+);/,) || '')[1];
    return fetch(url,).
      then(function (res,) {
        return res.arrayBuffer();
      },).
      then(function (buf,) {
        return new File([buf,], filename, { type: mimeType, },);
      },);
  };

  const fileBuffer = await urltoFile(
    fileData.base64,
    fileData.header.name,
    fileData.header.type,
  );

  const formData = new FormData();

  formData.set('key', policy.key,);
  formData.set('acl', policy.acl,);
  formData.set('success_action_status', policy.success_action_status,);
  formData.set('Content-Type', policy['Content-Type'],);
  formData.set('Policy', policy.Policy,);
  formData.set('X-Amz-Algorithm', policy['X-Amz-Algorithm'],);
  formData.set('X-Amz-Credential', policy['X-Amz-Credential'],);
  formData.set('X-Amz-Date', policy['X-Amz-Date'],);
  formData.set('X-Amz-Signature', policy['X-Amz-Signature'],);
  formData.append('file', fileBuffer, fileData.header.name,);

  const instance = axios.create();

  const lastHeaders = JSON.stringify(instance.defaults.headers.common,);

  instance.defaults.headers.common = {};

  const response = await instance({
    method: 'post',
    url: endpoint,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data', },
  },);

  instance.defaults.headers.common = JSON.parse(lastHeaders,);

  return response;
};

const getPaymentMethods = () => {
  return BaseHttp.get('/payments/methods',);
};

export default {
  get,
  getStates,
  getCities,
  getFilePolicy,
  uploadPublicImage,
  updatePublicImage,
  uploadFileWithPolicy,
  downloadFile,
  getPaymentMethods,
};
